// extracted by mini-css-extract-plugin
module.exports = {"headerBg":"App_headerBg__2lcH-","myComponent":"App_myComponent__NWaPp","next":"App_next__33bjl","next_disabled":"App_next_disabled__22Gav"};